import * as React from "react";
import { useFormContext } from "react-hook-form";
import { NGLabelText } from "../../../newcomponents/text/labelText";
import { FormDryRunAlert } from "./formDryRunAlert";
import { CreateNGAdvancedPortCors } from "./create_ng_advanced_port_cors";
import { CreateNGAdvancedPortTls } from "./create_ng_advanced_port_tls";
import { CreateNGAdvancedPortRoutes } from "./create_ng_advanced_port_routes";
import { FormNGInput } from "./components/FormNGInput";
import { FormNGSelect } from "./components/FormNGSelect";
import { DomainInput } from "./types/input";

interface Props {
  id: string;
}
export const CreateNGAdvancedPort: React.FC<Props> = ({ id }) => {
  const { control, watch } = useFormContext<DomainInput>();

  const fPorts = watch("advanced.spec.ports") || [];
  const index = React.useMemo(() => {
    return fPorts.findIndex((p) => p.id === id);
  }, [id, fPorts]);

  const fNumber = watch(`advanced.spec.ports.${index}.number` as const) || "";

  if (index < 0) {
    return null;
  }

  return (
    <div key={id}>
      <NGLabelText className="cursor-default">Port {fNumber}</NGLabelText>
      <div className="flex gap-2" style={{ width: 600 }}>
        <div>
          <div className="flex items-center">
            <NGLabelText className="cursor-default">Number</NGLabelText>
            <span className="color-danger">*</span>
          </div>
          <FormNGInput name={`advanced.spec.ports.${index}.number` as const} control={control} placeholder="443" />
        </div>
        <div>
          <div className="flex items-center">
            <NGLabelText className="cursor-default">Protocol</NGLabelText>
            <span className="color-danger">*</span>
          </div>
          <FormNGSelect
            name={`advanced.spec.ports.${index}.protocol` as const}
            control={control}
            options={[
              { label: "http", value: "http" },
              { label: "http2", value: "http2" },
              { label: "tcp", value: "tcp" },
            ]}
          />
        </div>
      </div>
      <div className="mb-12">
        <FormDryRunAlert path={`spec.ports[${index}].number`} paths={[`spec.ports[${index}].protocol`]} />
      </div>
      <CreateNGAdvancedPortRoutes id={id} index={index} />
      <CreateNGAdvancedPortTls id={id} index={index} />
      <CreateNGAdvancedPortCors id={id} index={index} />
    </div>
  );
};
